
export const isTabletOrMobile = () => {
  if (window.screen.width >= 1224) { 
    return false
  }
  return true
};

export const isDesktopOrLaptop = () => {
  if (window.screen.width > 1224) { 
    return true
  }
  return false
};